import { environment } from '@environments/environment';
import { ElasticSearchQueryInput } from '@services/elastic-search/models';

export const GET_STORES_BY_NAME_QUERY = (searchTerm: string, includeClosedStores = false): ElasticSearchQueryInput => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store ?? '',
  body: {
    size: 20,
    query: {
      bool: {
        filter: [
          { term: { search_api_datasource: 'entity:node' } },
          ...(includeClosedStores ? [] : [{ term: { status: true } }]),
        ],
        must: [
          {
            wildcard: {
              title: {
                value: `*${searchTerm}*`,
                case_insensitive: true,
              },
            },
          },
        ],
      },
    },
    sort: [{ title: { order: 'asc' } }],
  },
});
